export default __webpack_public_path__ + "static/media/fotoHome.8a1f255b.png";